import { useState } from "react";
import styled from "styled-components";
import { ArrowUpDown } from "lucide-react";

const SelectContainer = styled.div`
  margin: 1rem 0;
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.span`
  margin-right: 1rem;
`;

const SortIconWrapper = styled.div`
  border: 1px solid #083B4A;
  padding: 5px 8px;
  cursor: pointer;
  &:hover {
    background-color: #ededed;
  }
`;

const SelectRolesMobile = ({onSortingRolesData = (data: any) => {}}) => {
  const options = [
    { value: '', text: '-- Select --' },
    { value: 'clientName', text: 'Client' },
    { value: 'title', text: 'Job Title' },
    { value: 'industry', text: 'Industry' },
    { value: 'location', text: 'Location' },
    { value: 'workType', text: 'Type' },
    { value: 'matches', text: 'Matches' },
    { value: 'status', text: 'Status' },
  ];

  const [toggle, setToggle] = useState(options[0]?.value);

  const handleChange = (e: any) => {
    onSortingRolesData((e?.target as HTMLButtonElement).value);
    setToggle((e?.target as HTMLButtonElement).value);
  }

  return (
    <SelectContainer>
      <div>
        <Title>Sort by</Title>
        <select onChange={handleChange}>
          {options.map((item, i) => (
            <option key={item?.value ?? i} value={item?.value}>{item?.text}</option>
          ))}
        </select>
      </div>
      <SortIconWrapper onClick={() => onSortingRolesData(toggle)}>
        <ArrowUpDown size={15} color="#083B4A" />
      </SortIconWrapper>
    </SelectContainer>
  )
}

export default SelectRolesMobile;
